import './SearchGameItem.css';
import React, { useCallback, useContext } from 'react';
import { Image } from '../../../Image';
import { useDispatch } from 'react-redux';
import { useAsgActions } from '../../../../hooks/use-asg-actions.hook';
import { LoadGameConfirmContext } from '../../contexts/load-game-confirm.context';
import { GamesService } from '../../../../services/games.service';

export const SearchGameItem = ({
    game,
}) => {
    const { openGameWithConfirm, activateConfirmPopup } = useContext(LoadGameConfirmContext);
    const dispatch = useDispatch();
    const { loadGame } = useAsgActions();

    const openGame = useCallback(() => {
        if (!openGameWithConfirm) {
            dispatch(loadGame({
                gameId: game.id,
            }));
            return;
        }

        activateConfirmPopup(game);
    }, [game]);

    return (
        <div className="asg-search-results-item">
            <div className="asg-search-results-item__image">
                <Image
                    onClickHandler={openGame}
                    images={game.images}
                />
            </div>
            <div className="asg-search-results-item__info">
                <div className="asg-search-results-item__name">{game.name}</div>
                <div className="asg-search-results-item__provider">
                    {GamesService.getGameProviderName(game)}
                </div>
            </div>
            <div
                onClick={openGame}
                className="asg-search-results-item__play"
            ></div>
        </div>
    );
};
